import { render } from "./cans-flavour-row.vue?vue&type=template&id=6d4604f8"
import script from "./cans-flavour-row.vue?vue&type=script&lang=js"
export * from "./cans-flavour-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__